/* cert/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.intersection([
  t.type({}),
  t.partial({
    CA: t.boolean,
    CADescription: t.string,
    CASerialNumber: t.string,
    // CASK: t.string,
    CAX509DER: t.string,
    CAX509Chain: t.string,
    Description: t.string,
    SerialNumber: t.string,
    Protected: t.boolean,
    RevocationDate: t.string,
    RevocationReason: t.string,

    // if CSR file is supplied then none of these are required
    Country: t.string,
    State: t.string,
    Locality: t.string,
    Org: t.string,
    OrgUnit: t.string,
    Title: t.string,
    CommonName: t.string,
    Email: t.string,

    SAN: t.array(t.string),
    SANCritical: t.boolean,

    OCSP: t.array(t.string),
    OSCPCritical: t.boolean,

    ValidityInYears: t.number,
    DateStart: t.string,
    DateEnd: t.string,

    // SK: t.string,
    // SKPVC: t.string,
    // PK: t.string,
    // PKTrusted: t.string,

    CSR: t.string,
    X509: t.string,
    X509DER: t.string,
  }),
]);

type Attributes = t.TypeOf<typeof AttributeCodec>;
export type Error = t.TypeOf<typeof ErrorCodec>;

// export interface Data {
//   id: string | undefined | null;
//   type: string;
//   attributes: Attributes;
//   createdAt?: string;
//   updatedAt?: string;
//   children?: Array<Data>;
// }

// const DataCodec: t.Type<Data> = t.recursion("DataCodec", () =>
//   t.type({
//     id: tId,
//     type: t.string,
//     attributes: AttributeCodec,
//     createdAt: tOptional(t.string),
//     updatedAt: tOptional(t.string),
//     children: tOptional(t.union([t.null, t.array(DataCodec)]))
//   })
// );

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

// export interface caType {
//   desc: string;
//   serial: string;
// }

export type caType = t.TypeOf<typeof caCodec>;
const caCodec = t.type(
  {
    desc: t.string,
    serial: t.string,
  },
  "caCodec"
);

export interface ReasonType {
  reason: string;
  description: string;
}

export const reasons = [
  { reason: 'unspecified', description: 'Unspecified' },
  { reason: 'keyCompromise', description: 'Key was compromised' },
  { reason: 'CACompromise', description: 'CA was compromised' },
  { reason: 'affiliationChanged', description: 'Affiliation has changed' },
  { reason: 'superseded', description: 'Superseded' },
  { reason: 'cessationOfOperation', description: 'Operation has ceased' },
  { reason: 'certificateHold', description: 'Hold certificate' },
  { reason: 'removeFromCRL', description: 'Remove from CRL' },
  { reason: 'privelegeWithdrawn', description: 'Privilege withdrawn' },
  { reason: 'AACompromise', description: 'AA was compromised' },
];


export const CertCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "CertCodec"
);

export type Cert = t.TypeOf<typeof CertCodec>;

export enum CertActionTypes {
  FETCH = "@@cert/FETCH",
  FETCH_SUCCESS = "@@cert/FETCH_SUCCESS",
  FETCH_ERROR = "@@cert/FETCH_ERROR",
  SAVE_REQUEST = "@@cert/SAVE_REQUEST",
  SAVE_SUCCESS = "@@cert/SAVE_SUCCESS",
  SAVE_ERROR = "@@cert/SAVE_ERROR",
  DELETE_REQUEST = "@@cert/DELETE_REQUEST",
  DELETE_SUCCESS = "@@cert/DELETE_SUCCESS",
  DELETE_ERROR = "@@cert/DELETE_ERROR",
}

export interface CertState {
  readonly loading: boolean;
  readonly data: Cert | undefined;
  readonly errors?: string;
}
